import React from 'react';

// Иконки статуса конвертации — bulk16 по макету: залитый кружок с галочкой
// (готово), колокольчик (ждёт конвертации) и кружок с крестиком (ошибка).
// Раньше здесь был контурный linear16, у которого нет колокольчика.
import { CloseCircle, NotificationBing, TickCircle } from '@myua/icons/dist/bulk16';
import './styles.scss';

import { Popover } from '@myua/kit';
import { conversionStatusTranslations, FileManagerRow } from '../../model';
import { CHNodeIsFolder } from '../../../../../general/node';

export const InfoIcon = (
  <NotificationBing className="ch-conversion-status__icon ch-conversion-status__icon-info" />
);
// Маркер строки в списке ошибок внутри поповера — та же иконка ошибки, что и
// в самой ячейке: отдельного значка под это в макете нет.
export const ErrorItemIcon = (
  <CloseCircle className="ch-conversion-status__icon ch-conversion-status__icon-errorItem" />
);
export const ErrorIcon = (
  <CloseCircle className="ch-conversion-status__icon ch-conversion-status__icon-error" />
);
export const OKIcon = (
  <TickCircle className="ch-conversion-status__icon ch-conversion-status__icon-ok" />
);

export const ConversionStatusCellInner: React.FC<{
  cellData: any;
  rowData: FileManagerRow;
}> = ({ rowData }) => {
  const state = rowData.conversionState;

  if (state === null) {
    return <span></span>;
  }

  if (CHNodeIsFolder(rowData)) {
    const { message } = state;
    const translations = conversionStatusTranslations[message];
    // Всегда короткая формулировка: колонка узкая (по макету ~90px), и полная
    // фраза в неё не помещается ни при какой ширине окна — раньше её показывали
    // на широком экране, и статус превращался в обрезанное многоточием месиво.
    // Полная остаётся в `title` — по наведению и для скринридера.
    const messageString = translations !== undefined ? translations.short : `🔡${message}`;
    const fullMessage = translations !== undefined ? translations.full : messageString;
    const Icon = state.status === 'DONE' ? OKIcon : state.status === 'ERROR' ? ErrorIcon : InfoIcon;
    const body = (
      <span className="conversion-status-error__item" title={fullMessage}>
        {Icon}
        {messageString}
      </span>
    );

    const errorBody = (
      <div className="conversion-status-error">
        {state.errors.map((err, idx) => (
          <div className="conversion-status-error__item" key={idx}>
            {ErrorItemIcon}
            {err}
          </div>
        ))}
      </div>
    );

    return state.errors.length !== 0 ? (
      // Разметка со списком ошибок — Popover, не Tooltip.
      <Popover placement="bottom" content={errorBody}>
        {body}
      </Popover>
    ) : (
      body
    );
  } else {
    if (state.errors.length !== 0) {
      return (
        <span className="conversion-status-error__item">
          {ErrorItemIcon}
          {state.errors[0]}
        </span>
      );
    } else return <span></span>;
  }
};

export const ConversionStatusCell = (props: any) => <ConversionStatusCellInner {...props} />;
